import {createEventBus} from '@malt/vue-event-bus/create-event-bus';

export type OrganizationChangedEvent = {
    organizationId: string;
};

export type Events = {
    'companies:loaded': void;
    'filters:initialize': void;
    'filters:organization-changed': OrganizationChangedEvent;
    'filters:select-organization': OrganizationChangedEvent;
    'filters:reset-all': void;
};

export const companiesAndOrganizationEventBus = createEventBus<Events>();
